import { render, staticRenderFns } from "./BankMandateDeleteProvider.vue?vue&type=template&id=267c7b20&scoped=true&"
import script from "./BankMandateDeleteProvider.vue?vue&type=script&lang=ts&"
export * from "./BankMandateDeleteProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267c7b20",
  null
  
)

export default component.exports